<template>
  <Head :title="__('payment-success.meta.title')">
    <meta
      name="description"
      :content="__('payment-success.meta.description')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="order-5">
    <div class="md:container">
      <Link :href="localeRoute('frontend.index')">
        <img
          src="/frontend/assets/logo.svg"
          class="mt-10 hidden lg:block mx-auto"
        >
      </Link>

      <div class="bg-white lg:mt-10 lg:rounded-2xl px-5 py-7 lg:px-20 lg:py-10 lg:mb-8">
        <div class="w-full">
          <div class="text-center border-b border-gray-100 pb-4 lg:w-1/2 lg:mx-auto">
            <h1 class="text-2xl font-bold">
              {{ __('payment-success.title') }}
            </h1>
          </div>
        </div>

        <div class="mt-8 text-center">
          <h2 class="block text-4xl font-bold lg:text-5xl">
            {{ __('payment-success.text') }}
          </h2>

          <h3 class="block mt-6 text-2xl font-bold">
            {{ __('payment-success.flow.title') }}
          </h3>

          <div class="grid grid-cols-1 gap-2 border-b border-gray-100 pb-2 mt-6 md:grid-cols-1 md:gap-6 lg:px-36">
            <div class="">
              <p class="text-gray-500">
                We gaan de ShoutOut zonder ons logo maken. Je ontvangt binnen 5 minuten een link naar je ShoutOut.
              </p>
            </div>
          </div>
        </div>

        <div class="mt-4 lg:mt-8">
          <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:mt-8">
            <Vip
              v-for="alternativeVip in alternativeVips"
              :key="`vip-${alternativeVip.username}`"
              :vip="alternativeVip"
              :always-mobile="true"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Clean from '../../Layout/Clean.vue';
import Vip from '../../Components/Vip.vue';
import GoogleTagManager from '../../Mixins/GoogleTagManager';

export default {
  components: {
    Vip,
  },

  mixins: [GoogleTagManager],

  layout: Clean,

  props: {
    vip: {
      type: Object,
      required: true,
    },

    shoutOut: {
      type: Object,
      required: true,
    },

    payment: {
      type: Object,
      required: true,
    },

    giftedDiscountCode: {
      type: Object,
      required: true,
    },

    alternativeVips: {
      type: Array,
      required: true,
    },

    isPaid: {
      type: Boolean,
      default: false,
    },
  },

  mounted () {
    this.gtmPurchase(this.payment, this.vip, this.shoutOut);
  },
};
</script>
